import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';
import { memo, useEffect, useState } from 'react';

import { PICKLEBALL_PLACEHOLDER_IMAGE } from '@/utils/helpers/constants';

interface ImageWithFallbackProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallbackSrc?: string;
  fill?: boolean;
  priority?: boolean;
}

const ImageWithFallback = (props: ImageWithFallbackProps) => {
  const {
    src,
    fallbackSrc = getCDNURL(PICKLEBALL_PLACEHOLDER_IMAGE, 450, 450),
    fill,
    priority,
    ...rest
  } = props;
  const [imgSrc, setImgSrc] = useState(src);

  useEffect(() => {
    if (typeof src === 'string' && (src.startsWith('/') || src.startsWith('http'))) {
      setImgSrc(src);
    } else {
      setImgSrc(fallbackSrc);
    }
  }, [src, fallbackSrc]);

  const fillClassName = fill ? 'absolute inset-0 w-full h-full' : '';
  const loadingAttribute = priority ? 'eager' : 'lazy';

  return (
    <img
      src={imgSrc}
      onError={() => {
        setImgSrc(fallbackSrc);
      }}
      loading={loadingAttribute}
      {...rest}
      className={`${fillClassName} ${rest.className || ''}`}
      alt={props.alt}
    />
  );
};

export default memo(ImageWithFallback);
